/* Custom Product Enhancements - Kit Type Toggle (Space Goods Style) */

(function() {
  'use strict';

  // Prevent double initialization
  if (window.__kitTypeToggleInitialized) return;
  window.__kitTypeToggleInitialized = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Check if already initialized
    if (document.querySelector('.kit-type-toggle')) return;

    const sizeFieldset = document.querySelector('.product-form__input--pill:has(input[name="Size"])');
    if (!sizeFieldset) return;

    const framedInputs = document.querySelectorAll('input[name="Size"][value*="Framed"]');
    if (framedInputs.length === 0) return;

    // Create Kit Type Toggle - PBN compact style using table-cell for bulletproof layout
    // (table-cell prevents theme CSS from overriding to vertical stacking)
    const cardStyleActive = 'display: table-cell; vertical-align: middle; border-radius: 6px; padding: 6px 10px; cursor: pointer; border: 1.5px solid #C9A962; background: rgba(201, 169, 98, 0.06); white-space: nowrap;';
    const cardStyleInactive = 'display: table-cell; vertical-align: middle; border-radius: 6px; padding: 6px 10px; cursor: pointer; border: 1.5px solid rgba(26, 58, 74, 0.15); background: white; white-space: nowrap;';
    const emojiStyle = 'display: inline-block; width: 20px; height: 20px; background: rgba(26, 58, 74, 0.04); border-radius: 4px; text-align: center; line-height: 20px; font-size: 12px; vertical-align: middle; margin-right: 6px;';
    const titleStyle = 'font-weight: 500; font-size: 11px; color: #1a3a4a; text-transform: uppercase; vertical-align: middle;';

    const container = document.createElement('div');
    container.className = 'kit-type-section';
    container.innerHTML = `
      <div style="font-size: 0.85rem; font-weight: 600; color: #1a3a4a; margin-bottom: 0.4rem;">Kit Type</div>
      <div class="kit-type-toggle" style="display: table; border-spacing: 6px 0; margin-left: -6px; margin-bottom: 0.6rem;">
        <div class="toggle-card active" data-type="kit" style="${cardStyleActive}">
          <span class="emoji" style="${emojiStyle}">🎨</span><span class="title" style="${titleStyle}">Kit Only</span>
        </div>
        <div class="toggle-card" data-type="framed" style="${cardStyleInactive}">
          <span class="emoji" style="${emojiStyle}">🖼️</span><span class="title" style="${titleStyle}">With Frame</span>
        </div>
      </div>
    `;
    sizeFieldset.parentNode.insertBefore(container, sizeFieldset);

    const toggle = container.querySelector('.kit-type-toggle');

    const productForm = sizeFieldset.closest('.product-form') || sizeFieldset.closest('form') || document.body;

    const cards = toggle.querySelectorAll('.toggle-card');

    // Helper to update card styles
    function updateCardStyles() {
      cards.forEach(c => {
        if (c.classList.contains('active')) {
          c.style.cssText = cardStyleActive;
        } else {
          c.style.cssText = cardStyleInactive;
        }
      });
    }

    cards.forEach(card => {
      card.addEventListener('click', function() {
        const type = this.dataset.type;

        cards.forEach(c => c.classList.remove('active'));
        this.classList.add('active');
        updateCardStyles();

        if (type === 'framed') {
          productForm.classList.add('kit-type-framed');
        } else {
          productForm.classList.remove('kit-type-framed');
        }

        selectFirstAvailableSize(type);
      });
    });

    // Check if current variant is framed
    const currentSize = document.querySelector('input[name="Size"]:checked');
    if (currentSize && currentSize.value.includes('Framed')) {
      cards[0].classList.remove('active');
      cards[1].classList.add('active');
      productForm.classList.add('kit-type-framed');
      updateCardStyles();
    }
  }

  function selectFirstAvailableSize(type) {
    const isFramed = type === 'framed';
    const sizes = document.querySelectorAll('input[name="Size"]');

    for (const size of sizes) {
      const isFramedOption = size.value.includes('Framed');
      if (isFramed === isFramedOption && !size.classList.contains('disabled')) {
        size.checked = true;
        size.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }

  // Update button price when variant changes
  function initPriceUpdater() {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const btn = form.querySelector('.product-form__submit span');
    if (!btn) return;

    const updateButtonPrice = () => {
      const priceEl = document.querySelector('.price-item--regular, .price-item--sale');
      if (!priceEl) return;

      const price = priceEl.textContent.trim();
      const btnText = btn.textContent.trim();

      // Skip if sold out
      if (btnText.toLowerCase().includes('sold out')) return;

      // Always ensure price is shown
      if (!btnText.includes('·') || !btnText.includes(price)) {
        btn.textContent = 'Add to cart · ' + price;
      }
    };

    // Use MutationObserver to watch for button text changes
    const observer = new MutationObserver(() => {
      setTimeout(updateButtonPrice, 50);
    });
    observer.observe(btn, { childList: true, characterData: true, subtree: true });

    // Also watch for price changes
    const priceContainer = document.querySelector('.price');
    if (priceContainer) {
      const priceObserver = new MutationObserver(() => {
        setTimeout(updateButtonPrice, 50);
      });
      priceObserver.observe(priceContainer, { childList: true, characterData: true, subtree: true });
    }

    // Initial update
    updateButtonPrice();
  }

  initPriceUpdater();
})();
